/**
 * Extract a user-facing message from an API JSON body (axios `response.data`).
 */
export function getMessageFromResponseData(payload) {
  if (payload == null || payload === '') return ''
  if (typeof payload === 'string') return payload.trim() || ''

  const message = payload.message
  const detail = payload.data
  const errors = payload.errors

  if (Array.isArray(errors) && errors.length) {
    const msgs = errors
      .map((e) => (typeof e === 'string' ? e : e?.msg))
      .filter(Boolean)
    if (msgs.length) return [...new Set(msgs)].join('. ')
  }

  if (typeof detail === 'string' && detail.trim()) return detail.trim()

  if (typeof message === 'string' && message.trim()) {
    if (message === 'successful') return ''
    if (message === 'error' || message === 'Error') return ''
    return message.trim()
  }

  return ''
}

/**
 * User-facing error from a `postData` / `updateData` / `getData` result object.
 * Expects optional `axiosMessage` on the object when `error` is set (see `request.js`).
 */
export function getApiErrorMessage(requestResult, fallback = 'Something went wrong') {
  const axiosMessage = requestResult?.axiosMessage || ''
  const result = requestResult?.result

  if (!result) {
    if (axiosMessage === 'Network Error') {
      return 'Unable to reach the server. Check your connection and that the API is running.'
    }
    return axiosMessage || 'Unable to reach the server. Please try again.'
  }

  const fromBody = getMessageFromResponseData(result.data)
  if (fromBody) return fromBody

  const status = result.status
  if (status === 404) return 'The requested resource was not found.'
  if (status === 502 || status === 503) return 'The server is temporarily unavailable. Please try again later.'
  if (status >= 500) return 'Something went wrong on the server. Please try again later.'

  return fallback
}
